function isBoolean(x) {
    return typeof x === 'boolean';
}

export { isBoolean };
